// extracted by mini-css-extract-plugin
export var badge = "HappeningThumbnail-module--badge--f162d";
export var iconContainer = "HappeningThumbnail-module--iconContainer--3f55a";
export var image = "HappeningThumbnail-module--image--cf4f7";
export var imageWrapper = "HappeningThumbnail-module--imageWrapper--3073d";
export var large = "HappeningThumbnail-module--large--79986";
export var medium = "HappeningThumbnail-module--medium--26a5c";
export var newsTag = "HappeningThumbnail-module--newsTag--dd3a1";
export var pastEvent = "HappeningThumbnail-module--pastEvent--34efd";
export var small = "HappeningThumbnail-module--small--665f1";
export var text = "HappeningThumbnail-module--text--8b488";
export var wrapper = "HappeningThumbnail-module--wrapper--0aee5";